<template>
    <div v-if="activateValidation">
      <div class="v-error" v-if="validation.$dirty && !validation.required && validation.required !== undefined">{{label}} tidak boleh kosong</div>
      <div class="v-error" v-else-if="validation.$dirty && !validation.minLength && validation.$params.minLength">{{label}} minimal {{validation.$params.minLength.min}} karakter</div>
	    <div class="v-error" v-else-if="validation.$dirty && !validation.maxLength && validation.$params.maxLength">{{label}} maksimal {{validation.$params.maxLength.max}} karakter</div>
	    <div class="v-error" v-else-if="validation.$dirty && !validation.minValue && validation.minValue !== undefined">Minimal {{label}} adalah {{ validation.$params.minValue.min }}</div>
		<div class="v-error" v-else-if="validation.$dirty && !validation.maxValue && validation.maxValue !== undefined">Minimal {{label}} adalah {{ validation.$params.maxValue.max }}</div>
	    <div class="v-error" v-else-if="validation.$dirty && !validation.email && validation.email !== undefined">Format email salah</div>
	    <div class="v-error" v-else-if="validation.$dirty && !validation.sameAsPassword && validation.sameAsPassword !== undefined">Password tidak cocok</div>
      <div class="capslock v-error" style="display: none">Capslock sedang menyala</div>
    </div>
</template>

<script>
    export default {
        name: "ErrorMessage",
        props: ["label","validation"],
        data() {
            return {
                activateValidation: true,
                timeHandler: null,
                timer: "",
            }
        },
	    watch: {
		    validation: {
			    handler(validation){
				    validation.$touch();
				    if (validation.$dirty) {
					    this.invalidForm(validation.$invalid)
				    }
				    if (!this.activateValidation) {
				      this.activateValidation = true
            }
			    },
			    deep: true
		    },
		    immediate:true
	    },
	    methods: {
        	invalidForm(invalid) {
		        // if(invalid){
			    //     $(this.$el).prev().addClass("error-validate");
		        // }else{
			    //     $(this.$el).prev().removeClass("error-validate");
		        // }
	        },
	        resetValidation() {
        	  setTimeout(() => {
              this.activateValidation = false
            }, 100)
          },
	    }
    }
</script>
<style scoped>
    .v-error{
        color:red;
	    font-size: 14px;
	    margin-top: 4px;
    }
</style>